import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowContainerFullStore } from "../../../../../store";
import { Grid } from "@mui/material";
import { DividerComponent, OnlyPhoto } from "../../../../../../../libs/shared";

export const Documentos = () => {

  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white" }}
    >
      <TarjaDeCarga />
      <EvaluacionDeFruta />
      <GuiaDeTransporte />
      <DividerComponent label="Opcionales"/>
      <TarjaDeCargaOptional1 />
      <TarjaDeCargaOptional2 />
    </Grid>
  );
};

//DOCUMENTOS
const TarjaDeCarga = () => {
  const {
    open: openTarjaCarga,
    handleClose: handleCloseTarjaCarga,
    handleOpen: handleOpenTarjaCarga,
  } = useOpen();

  const tarjaCargaPhoto = useWorkflowContainerFullStore(
    (state) => state.tarjaCargaPhoto
  );

  const setTarjaCargaPhoto = useWorkflowContainerFullStore(
    (state) => state.setTarjaCargaPhoto
  );
  const fotoUrl = useBlobUrl(tarjaCargaPhoto);

  return (
    <Grid
      item
      xs={12}
      sm={6}

      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseTarjaCarga}
        handleOpen={handleOpenTarjaCarga}
        label="TARJA DE CARGA"
        open={openTarjaCarga}
        setFoto={setTarjaCargaPhoto}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

const EvaluacionDeFruta = () => {
  const {
    open: openEvaluacionFruta,
    handleClose: handleCloseEvaluacionFruta,
    handleOpen: handleOpenEvaluacionFruta,
  } = useOpen();

  const evaluacionFrutaPhoto = useWorkflowContainerFullStore(
    (state) => state.evaluacionFrutaPhoto
  );

  const setEvaluacionFrutaPhoto = useWorkflowContainerFullStore(
    (state) => state.setEvaluacionFrutaPhoto
  );
  const fotoUrl = useBlobUrl(evaluacionFrutaPhoto);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseEvaluacionFruta}
        handleOpen={handleOpenEvaluacionFruta}
        label="EVALUACIÓN DE FRUTA"
        open={openEvaluacionFruta}
        setFoto={setEvaluacionFrutaPhoto}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

const GuiaDeTransporte = () => {
  const {
    open: openGuiaTransporte,
    handleClose: handleCloseGuiaTransporte,
    handleOpen: handleOpenGuiaTransporte,
  } = useOpen();

  const guiaTransportePhoto = useWorkflowContainerFullStore(
    (state) => state.guiaTransportePhoto
  );

  const setGuiaTransportePhoto = useWorkflowContainerFullStore(
    (state) => state.setGuiaTransportePhoto
  );
  const fotoUrl = useBlobUrl(guiaTransportePhoto);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseGuiaTransporte}
        handleOpen={handleOpenGuiaTransporte}
        label="GUÍA DE TRANSPORTE"
        open={openGuiaTransporte}
        setFoto={setGuiaTransportePhoto}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

const TarjaDeCargaOptional1 = () => {
  const {
    open: openTarjaCarga,
    handleClose: handleCloseTarjaCarga,
    handleOpen: handleOpenTarjaCarga,
  } = useOpen();

  const tarjaCargaPhoto = useWorkflowContainerFullStore(
    (state) => state.tarjaCargaPhotoOptional1
  );

  const setTarjaCargaPhoto = useWorkflowContainerFullStore(
    (state) => state.setTarjaCargaPhotoOptional1
  );
  const fotoUrl = useBlobUrl(tarjaCargaPhoto);

  return (
    <Grid
      item
      xs={12}
      sm={6}

      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseTarjaCarga}
        handleOpen={handleOpenTarjaCarga}
        label="TARJA DE CARGA 1"
        open={openTarjaCarga}
        setFoto={setTarjaCargaPhoto}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

const TarjaDeCargaOptional2 = () => {
  const {
    open: openTarjaCarga,
    handleClose: handleCloseTarjaCarga,
    handleOpen: handleOpenTarjaCarga,
  } = useOpen();

  const tarjaCargaPhoto = useWorkflowContainerFullStore(
    (state) => state.tarjaCargaPhotoOptional2
  );

  const setTarjaCargaPhoto = useWorkflowContainerFullStore(
    (state) => state.setTarjaCargaPhotoOptional2
  );
  const fotoUrl = useBlobUrl(tarjaCargaPhoto);

  return (
    <Grid
      item
      xs={12}
      sm={6}

      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseTarjaCarga}
        handleOpen={handleOpenTarjaCarga}
        label="TARJA DE CARGA 2"
        open={openTarjaCarga}
        setFoto={setTarjaCargaPhoto}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

